import React, { useEffect, useState } from 'react'
import Header from '../../../component/Produzioni/Header'
import DashboardCard from '../../../component/Produzioni/DashboardCard';
import TableInputPressatura from '../../../component/Produzioni/TableInputPressatura';
import TrattamentiFrom from '../../../component/Produzioni/TrattamentiFrom';
import { resetFormSubmit, storeFormData } from '../../../features/produzioniFormData/produzioniFormDataSlice';
import produzioniFormAPI from '../../../services/produzioniFormApi';
import { useDispatch, useSelector } from 'react-redux';

const PressaturaeSvinatura = ({option, activeStep, setActiveStep }) => {
    const dispatch = useDispatch();
    const singleProduzioneID = useSelector((state) => state.produzioni.singleProduzioneId);
    const submitForm = useSelector((state) => state.produzioniForm.submitForm);

    const [tableData, setTableData] = useState([
        { company_id: Number(localStorage.getItem('company_id')) || "", step: activeStep, prod_id:  singleProduzioneID, date_pressatura: null, qty_vinaccia_ottenuta: "", percentage_resta_in_mosto: "", Ph_del_vino_svinato: "" },
    ]);

    const [treatment, setTreatment] = useState([
        { company_id: Number(localStorage.getItem('company_id')) || "", step: activeStep, prod_id: singleProduzioneID, pro_treatment_id: "", tratt_date: null, pro_utilizzato: "", pro_qty: "", mod_di_applicazione: "", operatore_id: "", sicurezza: "" }
    ]);


    const data = {
        id: 1,
        title: "Pressatura e svinatura",
        description:
            "Ottimizza la resa separando con precisione il vino dalla vinaccia senza alterare le caratteristiche organolettiche.",
        buttonText: "Completa fase",
    };

    const temperatureCompliance = tableData.reduce((acc, item) => acc + Number(item.qty_vinaccia_ottenuta), 0);
    const discardedGrapes = tableData.reduce((acc, item) => acc + Number(item.percentage_resta_in_mosto), 0);
    const Ph_del_vino_svinato = tableData.reduce((acc, item) => acc + Number(item.Ph_del_vino_svinato), 0)/tableData.length;

    const dummyData = {

        temperatureCompliance: temperatureCompliance + " Kg",
        totalCollected:  temperatureCompliance > 0 
        ? ((discardedGrapes / temperatureCompliance) * 100).toFixed(2) + "%" 
        : "0%",
        discardedGrapes: discardedGrapes + " Lt",
        ph: Ph_del_vino_svinato,
        tasks: [
            "Separazione del vino dalla vinaccia",
            "Pressatura residui solidi",
        ],
    };

    const infoFields = [
        { label: "Q.ta Totale Vinaccia", key: dummyData.temperatureCompliance, showIcon: true },
        { label: "% Resa del mosto", key: dummyData.totalCollected },
        { label: "Resa del mosto", key: dummyData.discardedGrapes },
        { label: "Conformità PH", key: dummyData.ph },
    ];

    const fetchDataForUpdate = async () => {
        try {
          const payload = {
            company_id: localStorage.getItem('company_id'),
            step: activeStep,
            prod_id: singleProduzioneID,
          };
    
          const response = await produzioniFormAPI.getSingleStepFormData(payload);
          console.log(response, "response racolta")
          if (response?.data.data.svinatura?.length) {
            const existingTable = response.data.data.svinatura;
            setTableData(existingTable);
          }
          if (response?.data.data.production_step_treatment?.length) {
            const existingTreatment = response.data.data.production_step_treatment;
            setTreatment(existingTreatment);
          }
        } catch (error) {
          console.error("Error fetching single step form data:", error);
        }
      };
      
      useEffect(() => {
          fetchDataForUpdate();
      }, []);    

    const onSubmit = async (tableData, treatment) => {
        const data = {
            step: activeStep,
            forms: {
                svinatura: tableData,
                production_step_treatment: treatment
            }
        }
        console.log("Submitted data:", data);
        try {
              await produzioniFormAPI.updateStepFormData(singleProduzioneID, data);
        
            setActiveStep((prev) => prev + 1);
          } catch (error) {
            fetchDataForUpdate();
            console.error('Error submitting form data:', error);
          }
    };

    useEffect(() => {
        if (submitForm) {
            onSubmit(tableData, treatment);
            dispatch(resetFormSubmit());
        }
    }, [submitForm, dispatch]);

    return (
        <>
            <Header data={data} setActiveStep={setActiveStep} activeStep={activeStep} />
            <DashboardCard dummyData={dummyData} infoFields={infoFields} />
            <TableInputPressatura 
            option={option} 
            rows={tableData}
                setRows={setTableData}
                activeStep={activeStep}
                />
            <TrattamentiFrom 
            option={option} 
            rows={treatment}
                setRows={setTreatment}
                activeStep={activeStep}
                />
        </>
    )
}

export default PressaturaeSvinatura